import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  addProfileBusiness,
  editProfileBusiness,
  listProfileBusinessHourByProfileId,
  listProfileSpecialDayByProfileId,
  removeProfileBusiness,
} from "./thunkAction";

const initialState = {
  profileBusinessHours: [],
  profileSpecialDays: [],
  loading: false,
  error: null,
  isLoadingAddProfileBusiness: false,
  addProfileBusinessError: null,
};

const profileBusinessSlice = createSlice({
  name: "profileBusinessManage",
  initialState,
  reducers: {
    clearProfileBusiness(state) {
      state.profileBusinessHours = [];
      state.profileSpecialDays = [];
    },
    setProfileBusinessHours(state, action) {
      state.profileBusinessHours = _.get(action, "payload", []);
    },
    setProfileSpecialDays(state, action) {
      state.profileSpecialDays = _.get(action, "payload", []);
    },
    resetProfileError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // listProfileBusinessHourByProfileId
      .addCase(listProfileBusinessHourByProfileId.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        listProfileBusinessHourByProfileId.fulfilled,
        (state, action) => {
          state.error = null;
          state.loading = false;
          state.profileBusinessHours = _.get(action, "payload", []);
        }
      )
      .addCase(listProfileBusinessHourByProfileId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // listProfileSpecialDayByProfileId
      .addCase(listProfileSpecialDayByProfileId.pending, (state) => {
        state.loading = true;
      })
      .addCase(listProfileSpecialDayByProfileId.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.profileSpecialDays = _.get(action, "payload", []);
      })
      .addCase(listProfileSpecialDayByProfileId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // addProfileBusiness
      .addCase(addProfileBusiness.pending, (state) => {
        state.isLoadingAddProfileBusiness = true;
        state.addProfileBusinessError = null;
      })
      .addCase(addProfileBusiness.fulfilled, (state, action) => {
        state.isLoadingAddProfileBusiness = false;
      })
      .addCase(addProfileBusiness.rejected, (state, action) => {
        state.isLoadingAddProfileBusiness = false;
        state.addProfileBusinessError = action.payload;
      })
      // editProfileBusiness
      .addCase(editProfileBusiness.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editProfileBusiness.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editProfileBusiness.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // removeProfileBusiness
      .addCase(removeProfileBusiness.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeProfileBusiness.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(removeProfileBusiness.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const profileBusinessReducer = profileBusinessSlice.reducer;

export const profileBusinessAction = profileBusinessSlice.actions;
